import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { componentWithFG } from '@atlassian/jira-feature-gate-component/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { helpCenterSettingsCustomerAccessRoute } from '@atlassian/jira-router-routes-help-center-settings-routes/src/helpCenterSettingsCustomerAccessRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { navigation } from './common/constants.tsx';
import {
	HelpCenterSettingsCustomerAccess,
	LazyHelpCenterSettingsCustomerAccess,
} from './ui/customer-access/index.tsx';

export const helpCenterSettingsCustomerAccessRouteEntry = createEntry(
	helpCenterSettingsCustomerAccessRoute,
	() => ({
		perfMetricKey: 'help-center-settings.customer-access',
		layout: serviceProjectLayout,
		navigation,

		component: componentWithFG(
			'jcs_master_flag',
			HelpCenterSettingsCustomerAccess,
			ErrorPagesNotFound,
		),

		forPaint: [LazyAtlassianNavigation, LazyHelpCenterSettingsCustomerAccess],
		resources: [...getServiceDeskSettingsResources()],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-help-center-settings-entries/src/helpCenterSettingsCustomerAccessRouteEntry.tsx',
				whichExportToUse: 'helpCenterSettingsCustomerAccessRouteEntry',
			},

			enabled: true,
		},
	}),
);
